<template>
  <v-container class="you-may-also-like">
    <h3 class="text-left">You may also like</h3>
    <template v-if="similarPages.length > 0">
      <v-row>
        <v-col
          v-for="(page, index) in similarPages"
          :key="index"
          cols="6"
          md="3"
        >
          <v-card
            color="transparent"
            flat
            tile
            :to="`/blog/${page.id}`"
          >
            <v-img
              aspect-ratio="1.7778"
              max-height="150px"
              :lazy-src="page.image.thumbnail"
              :src="page.image.url"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card-title
              class="px-0 py-2"
            >{{page.title}}</v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col>
          <p class="text-center">There are no related recipes on this post.</p>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import {
  VCard,
  VCardTitle,
  VCol,
  VContainer,
  VImg,
  VProgressCircular,
  VRow,
} from 'vuetify/lib'

import {PageDocument} from '@/utils/types'

export default {
  components: {
    VCard,
    VCardTitle,
    VCol,
    VContainer,
    VImg,
    VProgressCircular,
    VRow,
  },
  computed: {
    similarPages() {
      return this.pages.filter((page) => page.id !== this.pageId)
    }
  },
  data: () => ({
    pages: [],
  }),
  mounted() {
    if (!this.tags) {
      return
    }

    let query = PageDocument.Collection
        .where('published', '==', true)

    if (this.tags.length > 0) {
        const tags = this.tags.slice(0, Math.min(this.tags.length, 10))

        query = query.where('tags', 'array-contains-any', tags)
    }

    this.$bind('pages', query).then(() => {})
  },
  props: {
    pageId: String,
    tags: Array,
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 22px;
  text-transform: none !important;
}

.you-may-also-like {
  font-size: 15px;

  .v-card__title {
    font-size: 18px;
    word-break: normal;
  }
}
</style>
